import NoHotelsAvailable from '@/views/NoHotelsAvailable/index.vue'

const NoHotelsAvailableRouter = {
  path: '/no-hotels-available',
  name: 'NoHotelsAvailable',
  component: NoHotelsAvailable,
  props: (route) => ({
    secret: route.query.secret,
    has_booked_failed: route.query.has_booked_failed
  })
}

export default NoHotelsAvailableRouter
